export default __webpack_public_path__ + "static/media/bg-test-access-dark.7e57a7fc.jpg";